export const SinglePlanOverviewModalInput = [
  {
    label: "Exercise Number",
    type: "text",
    id: "exerciseNumber",
    valueKey: "exercise_number",
  },
  {
    label: "Exercise Name",
    type: "text",
    id: "exerciseName",
    valueKey: "name",
  },

  {
    label: "Exercise Type",
    type: "select",
    id: "exerciseType",
    options: ["Normal", "Superset", "Dropset"],
    valueKey: "exercise_type",
    disabled: true,
  },
  {
    label: "Time Based",
    type: "text",
    id: "timeBased",
    valueKey: "time_based",
    disabled: true,
  },
  {
    label: "Weighted",
    type: "select",
    id: "weighted",
    options: ["Yes", "No"],
    valueKey: "weighted",
    disabled: true,
  },
  {
    label: "Sets",
    type: "text",
    id: "sets",
    valueKey: "sets",
    disabled: true,
  },
  {
    label: "Reps",
    type: "text",
    id: "reps",
    valueKey: "reps",
    disabled: true,
  },
  {
    label: "Set Time",
    type: "text",
    id: "setTime",
    valueKey: "set_time",
    disabled: true,
  },
  {
    label: "Rest Time",
    type: "text",
    id: "restTime",
    valueKey: "rest_time",
    disabled: true,
  },
  {
    label: "Video URL",
    type: "text",
    placeholder: "Enter video URL",
    valueKey: "video_url",
    disabled: true,
  },
  {
    label: "Image URL",
    type: "text",
    placeholder: "Enter image URL",
    valueKey: "image_url",
    disabled: true,
  },
];
